import { createSelector } from 'reselect';
import getFilteredTags from './getFilteredTags';

const getSelectedTag = state => state.tags.selected;

/**
  @name findSelectedTag
  Selector to obtain the selected tag from the selected id
*/
const findSelectedTag = createSelector(
  [getFilteredTags, getSelectedTag],
  (tags, selected) =>
    selected &&
    tags.find(tag => tag.id === selected)
);

export default findSelectedTag;



// WEBPACK FOOTER //
// ./src/utils/selectors/findSelectedTag.js